import { NavLink } from 'react-router-dom';
import { signOut } from '@/hooks/useAuth';

interface NavItem {
  path: string;
  icon: string;
  label: string;
}

const navItems: NavItem[] = [
  { path: '/', icon: 'ri-dashboard-3-line', label: 'Dashboard' },
  { path: '/produtos', icon: 'ri-shirt-line', label: 'Produtos' },
  { path: '/vendas', icon: 'ri-shopping-bag-3-line', label: 'Vendas' },
  { path: '/clientes', icon: 'ri-user-3-line', label: 'Clientes' },
  { path: '/despesas', icon: 'ri-bill-line', label: 'Despesas' },
  { path: '/aportes', icon: 'ri-arrow-down-circle-line', label: 'Aportes' },
  { path: '/retiradas', icon: 'ri-arrow-up-circle-line', label: 'Retiradas' },
  { path: '/retirada-produtos', icon: 'ri-gift-line', label: 'Ret. Produtos' },
];

interface SidebarProps {
  collapsed: boolean;
  onToggle: () => void;
}

export default function Sidebar({ collapsed, onToggle }: SidebarProps) {
  return (
    <aside
      className={`fixed left-0 top-0 h-full z-40 flex flex-col bg-dark-card border-r border-dark-border transition-all duration-300 ease-in-out ${collapsed ? 'w-16' : 'w-56'}`}
    >
      <div className="flex items-center justify-center h-16 px-4 border-b border-dark-border shrink-0">
        {!collapsed && (
          <div className="flex items-center gap-2.5 animate-fade-in">
            <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-neon/10 border border-neon/20">
              <i className="ri-store-3-fill text-neon text-base"></i>
            </div>
            <span className="uppercase text-white text-lg leading-none" style={{ fontFamily: "'Orbitron', sans-serif", fontWeight: 800, letterSpacing: '0.08em' }}>PIOT<span className="text-neon">FIT</span></span>
          </div>
        )}
        {collapsed && (
          <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-neon/10 border border-neon/20 mx-auto">
            <i className="ri-store-3-fill text-neon text-base"></i>
          </div>
        )}
      </div>

      <nav className="flex-1 py-4 overflow-y-auto">
        <ul className="space-y-1 px-2">
          {navItems.map((item) => (
            <li key={item.path}>
              <NavLink
                to={item.path}
                end={item.path === '/'}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2.5 rounded-lg cursor-pointer transition-all duration-200 group whitespace-nowrap
                  ${isActive ? 'bg-neon/10 text-neon border border-neon/20' : 'text-dark-muted hover:text-dark-text hover:bg-dark-card2'}`
                }
              >
                {({ isActive }) => (
                  <>
                    <div className="w-5 h-5 flex items-center justify-center shrink-0">
                      <i className={`${item.icon} text-lg ${isActive ? 'text-neon' : ''}`}></i>
                    </div>
                    {!collapsed && <span className="text-sm font-medium">{item.label}</span>}
                    {!collapsed && isActive && <div className="ml-auto w-1.5 h-1.5 rounded-full bg-neon shrink-0"></div>}
                  </>
                )}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      <div className="border-t border-dark-border p-3 shrink-0 space-y-1">
        <button
          onClick={() => signOut()}
          className="w-full flex items-center gap-2 py-2 px-3 rounded-lg text-dark-muted hover:text-red-400 hover:bg-red-500/10 transition-all cursor-pointer"
          title="Sair"
        >
          <div className="w-5 h-5 flex items-center justify-center shrink-0">
            <i className="ri-logout-box-r-line text-lg"></i>
          </div>
          {!collapsed && <span className="text-xs">Sair</span>}
        </button>
        <button
          onClick={onToggle}
          className="w-full flex items-center justify-center gap-2 py-2 px-3 rounded-lg text-dark-muted hover:text-dark-text hover:bg-dark-card2 transition-all cursor-pointer"
        >
          <div className="w-5 h-5 flex items-center justify-center">
            <i className={`${collapsed ? 'ri-arrow-right-s-line' : 'ri-arrow-left-s-line'} text-lg`}></i>
          </div>
          {!collapsed && <span className="text-xs">Recolher</span>}
        </button>
      </div>
    </aside>
  );
}
